/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// extract from apps/bot/src/constant/app.ts
export enum BaseEnum {
  Home = 'home', //Home
  Explore = 'explore', //explore
  Store = 'store', // store
  Model = 'model', //Model Arena
  Space = 'space', //In space
  Workflow = 'work_flow', //Compatible workflow edit page
  Invite = 'invite', // invite link
  Token = 'token', // token
  Open = 'open', // open API
  PluginMockSet = 'plugin_mock_set',
  Search = 'search', // Search
  Premium = 'premium', // subscription service
  User = 'user', // personal homepage
  Enterprise = 'enterprise', // Business Management
}

export enum SpaceAppEnum {
  BOT = 'bot',
  DOUYIN_BOT = 'douyin-bot',
  DEVELOP = 'develop',
  LIBRARY = 'library',
  MODEL = 'model',
  PLUGIN = 'plugin',
  OCEAN_PROJECT = 'ocean-project',
  WORKFLOW = 'workflow',
  KNOWLEDGE = 'knowledge',
  TEAM = 'team',
  PERSONAL = 'personal',
  WIDGET = 'widget',
  EVALUATION = 'evaluation',
  EVALUATE = 'evaluate',
  SOCIAL_SCENE = 'social-scene',
  IMAGEFLOW = 'imageflow',
  DATABASE = 'database',
  PROJECT_IDE = 'project-ide',
  PUBLISH = 'publish',
}
